module.exports = __webpack_public_path__ + "static/media/gensuite-india.8f24b126.png";